export {RecordKind as InputMode} from 'core/Record';
